export default {
  borderRadius: '1rem',
  border: '0px solid transparent',
  background: '#fff',
  padding: '1rem',
};
